import { type FormEvent, useState } from "react";
import type { HomeWidget } from "../../api/hub/home";
import { SourceLink } from "../focus/shared";
import { DataSource, DataState, MoreButton } from "./Frame";
import { listItems, useDataList } from "./data";
type Hit = {
  id: string;
  title: string;
  labels: string[];
  links: string[];
  passages?: { text: string }[];
};
export function KnowledgeSearch({ widget }: { widget: HomeWidget }) {
  const [input, setInput] = useState(""),
    [submitted, setSubmitted] = useState(""),
    [error, setError] = useState("");
  const query = useDataList<Hit>(
      "kb_search",
      { query: submitted, limit: 5 },
      !!submitted,
    ),
    items = listItems(query.data?.pages);
  const search = (e: FormEvent) => {
    e.preventDefault();
    const text = input.trim();
    if (!text) {
      setError("先输入要找的问题或资料名称");
      return;
    }
    if (text.length > 500) {
      setError("检索词最多 500 字，请缩短后重试");
      return;
    }
    setError("");
    if (text === submitted) void query.refetch();
    else setSubmitted(text);
  };
  return (
    <>
      <form className="home-kb-search" onSubmit={search}>
        <label htmlFor={"search-" + widget.id}>找依据，再做判断</label>
        <div className="home-search-row">
          <input
            id={"search-" + widget.id}
            value={input}
            maxLength={500}
            onChange={(e) => setInput(e.target.value)}
            placeholder={typeof widget.config.placeholder === "string"
              ? widget.config.placeholder
              : "输入一个问题或资料名称"}
          />
          <button
            type="submit"
            className="home-primary"
            disabled={query.isFetching}
          >
            检索
          </button>
        </div>
      </form>
      {error && <p role="alert" className="home-error">{error}</p>}
      {!submitted
        ? (
          <p className="home-muted">
            点击检索才会查询，结果保留原文审核与派生整理标记。
          </p>
        )
        : (
          <DataState
            query={query}
            isEmpty={!items.length}
            empty="当前授权范围内没有找到资料，请换一个关键词。"
          >
            {items.map((hit) => (
              <article className="home-data-row" key={hit.id}>
                <h3>{hit.title}</h3>
                <div className="home-row-meta">
                  {hit.labels?.map((label, i) => (
                    <span
                      key={i}
                      className={"home-tag " +
                        (/未审核|未经人审/.test(label) ? "home-warn-tag" : "")}
                    >
                      {label}
                    </span>
                  ))}
                </div>
                {hit.passages?.slice(0, 2).map((passage, i) => (
                  <p key={i}>{passage.text}</p>
                ))}
                <div className="home-actions">
                  {hit.links?.map((href, i) => (
                    <SourceLink key={i} href={href}>
                      核对原文 {i + 1} ↗
                    </SourceLink>
                  ))}
                </div>
              </article>
            ))}
            {query.data?.pages[0]?.data && "note" in query.data.pages[0].data &&
              (
                <p className="home-muted">
                  {String(query.data.pages[0].data.note)}
                </p>
              )}
            <MoreButton query={query} />
            <DataSource result={query.data?.pages.at(-1)} href="/kb" />
          </DataState>
        )}
    </>
  );
}
